import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-param',
  templateUrl: './modify-param.component.html',
  styleUrls: ['./modify-param.component.css']
})
export class ModifyParamComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []
  paramId: any ="";
  cid:any


  paramTypes = [
    "USERPARAMS",
    "CUSTREG",
    "ADMIN",
    'MDPARAMS',
    'USERTYPE',
    'PRODUCTPARAMS',
    "TICKETPARAM",
    "TASKPARAM",
    "PROSPECT"
  ]

  type = [
    "Input",
    "Checkbox",
    "File",
    "Image",
    "Dropdown"
  ]
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getParamsData()
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      type: ['',[Validators.required]],
      isMandatory: [''],
      predefinedParameterId: [''],
      boxType: [''],
      possibleValue:this.fb.array([])
    })  
  }

  onTableDataChange(event: any) {
    this.getParamsData();
  }

  onTableSizeChange(event: any): void {

    this.getParamsData();
  }

  get paramArr(){
    return this.form.get('possibleValue') as FormArray;
  }

  possibleValue(){
    return this.fb.group({
      "key":['']
    })
  }
  addpossibleValue(){
    this.paramArr.push(this.possibleValue())
  }
  
  removepossibleValue(index: number){
    this.paramArr.removeAt(index)
  }

  updateParam(){
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }

    let arr = []
    arr = this.form.get('possibleValue').value
    let possible = []

    for(var i = 0; arr.length > i;i++){
      if(arr[i].key != ""){
        possible.push(arr[i].key)
      }
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": String(this.form.get('name').value),
      "predefinedParameterId": this.form.get('predefinedParameterId').value,
      "type": String(this.form.get('type').value),
      "boxType": this.form.get('boxType').value,
      "isMandatory": this.form.get('isMandatory').value,
      "possibleValue": possible,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateParam(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getParamsData()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getParamsData(){
    this.generic_service.getParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  removepossibleValue1(){
    this.paramArr.clear()
  }

  getParamById(id:any){
    this.paramId = id
    this.form.reset()
    this.removepossibleValue1()
    this.generic_service.getParamById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.form.patchValue({
          name: response.response.name,
          type: response.response.type,
          predefinedParameterId: response.response.predefinedParameterId,
          boxType: response.response.boxType,
          isMandatory: response.response.isMandatory,
        })
        for(var i=0; i<response.response.possibleValue.length; i++){
          let obj = this.fb.group({
            "key":[response.response.possibleValue[i]]
          })
          this.paramArr.push(obj)
        }
        console.log(this.form.value)

      },
      (error)=>{
        console.log(error)
      }
    )
  }

  boxTypeChange(){
    if(this.form.get('boxType').value != "Dropdown"){
      while (this.paramArr.length !== 0) {
        this.paramArr.removeAt(0)
      }
    }else{
      this.addpossibleValue() 
    }
  }

}